import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { CreateNotification } from "../../../components/notifier";

interface AcceptRefuseProcessModalType {
    onClose: () => void;
    isOpen: boolean;
    action: string;
    status: string;
    handleConfirm: (textValue: string, status: string) => void;
}

const AcceptRefuseProcessModal =  (props: AcceptRefuseProcessModalType) => {
    const { onClose, isOpen, action, status, handleConfirm } = props;
    const [textValue, setTextValue] = useState('' as string);

    const handleConfirmClick = () => {
      if (action !== "approve") {
        if (!textValue) {
          CreateNotification({
            title: "Thông báo",
            body: `Anh/chị vui lòng nhập lý do không đạt ở bước ${status}`,
            icon: "/icons/warning.png",
          });
        } else {
          handleConfirm(textValue, status);
          onClose();
        }
      } else {
        handleConfirm(textValue, status);
        onClose();
      }
    };

    useEffect(() => {
      setTextValue("");
    }, [isOpen]);

    return (
      <Modal show={isOpen} onHide={onClose} centered size={"lg"} className="add-folder-modal" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>{status} tài liệu</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-4 px-4">
            <div className="d-flex column">
              <span style={{paddingRight: '10px', whiteSpace: 'nowrap'}}>Ghi chú</span>
              <textarea onChange={(e: any) => setTextValue(e.target.value)} style={{ width: "100%" }} />
            </div>
            
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onClose} variant="secondary">
            Hủy
          </Button>
          <Button onClick={handleConfirmClick} variant="info">
            Xác nhận
          </Button>
        </Modal.Footer>
      </Modal>
    );
};

export default AcceptRefuseProcessModal;